import { render, staticRenderFns } from "./MontanaAvisoLegal.vue?vue&type=template&id=c0ce1bde&"
import script from "./MontanaAvisoLegal.vue?vue&type=script&lang=js&"
export * from "./MontanaAvisoLegal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports